import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Select,
  MenuItem,
  Button,
  FormControl,
  InputLabel,
} from "@mui/material";
import { useEffect, useState } from "react";
import api from "../../api/axios";
import { toast } from "react-toastify";
import { getRoles } from "../../services/rolServices";

export default function UserAssignRoleModal({
  open,
  user,
  onClose,
  onSuccess,
}) {
  const [roles, setRoles] = useState([]);
  const [selectedRole, setSelectedRole] = useState("");

  const fetchRoles = async () => {
    try {
      const response = await getRoles();
      setRoles(response.data);
      
    } catch (error) {
      toast.error("No se pudieron cargar los roles");
    }
  };

  useEffect(() => {
    if (open) {
      fetchRoles();
    }
  }, [open]);

  useEffect(() => {
    if (user) {
      setSelectedRole(user.role_id || ""); // o user.role si viene el ID
    }
  }, [user]);

  const handleAssign = async () => {
    try {
      await api.post("/api/v1/roles/assign_role_to_user", {
        user_id: user.id,
        role_id: selectedRole, // este debe ser el ID numérico del rol
      });

      toast.success("Rol asignado correctamente");
      onSuccess?.(); // refrescar lista si querés
      onClose();
    } catch (err) {
      toast.error("Error al asignar rol");
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Asignar rol a {user?.name}</DialogTitle>
      <DialogContent>
        <FormControl fullWidth>
          <InputLabel id="select-role-label">Rol</InputLabel>
          <Select
            labelId="select-role-label"
            value={selectedRole}
            onChange={(e) => setSelectedRole(e.target.value)}
            fullWidth
          >
            {roles.map((role) => (
              <MenuItem key={role.id} value={role.id}>
                {role.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button onClick={handleAssign} variant="contained">
          Asignar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
